import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

import { EMAIL_MARKETING_MASTER_SWITCH_FIELD } from '../constants';

const getMarketingNewsEmailSubscribed = (state) => resolveProp('profile.mktg.newsEmailSubscribed', state);
const getMarketingOffersEmailSubscribed = (state) => resolveProp('profile.mktg.offersEmailSubscribed', state);
const getMarketingTipsEmailSubscribed = (state) => resolveProp('profile.mktg.tipsEmailSubscribed', state);
const getMarketingInfoEmailSubscribed = (state) => resolveProp('profile.mktg.infoEmailSubscribed', state);
const getMarketingPreferencesVersion = (state) => resolveProp('profile.data.mktgPreferencesVersion', state);
const getMarketingRtcEmailSubscribed = (state) => resolveProp('profile.mktg.rtcEmailSubscribed', state);
const getMarketingCoachEmailSubscribed = (state) => resolveProp('profile.mktg.coachEmailSubscribed', state);

export default createSelector(
    getMarketingNewsEmailSubscribed,
    getMarketingOffersEmailSubscribed,
    getMarketingTipsEmailSubscribed,
    getMarketingInfoEmailSubscribed,
    getMarketingPreferencesVersion,
    getMarketingRtcEmailSubscribed,
    getMarketingCoachEmailSubscribed,
    (
        newsEmailSubscribed,
        offersEmailSubscribed,
        tipsEmailSubscribed,
        infoEmailSubscribed,
        mktgPreferencesVersion,
        rtcEmailSubscribed,
        coachEmailSubscribed,
    ) => {
        const preferences = {
            newsEmailSubscribed,
            offersEmailSubscribed,
            tipsEmailSubscribed,
            infoEmailSubscribed,
            mktgPreferencesVersion,
            rtcEmailSubscribed,
            coachEmailSubscribed,
        };

        return {
            ...preferences,
            // Master switch should be set to true if any preferences are true
            [EMAIL_MARKETING_MASTER_SWITCH_FIELD]: Object.values(preferences).some((pref) => pref === true),
        };
    },
);
